import { render, staticRenderFns } from "./paypal.vue?vue&type=template&id=641702f2&scoped=true"
import script from "./paypal.vue?vue&type=script&lang=js"
export * from "./paypal.vue?vue&type=script&lang=js"
import style0 from "./paypal.vue?vue&type=style&index=0&id=641702f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641702f2",
  null
  
)

export default component.exports